import LazyLoad from "vanilla-lazyload";


const configureLazy = () => {
	
	const imageCollection = document.querySelectorAll('picture.lazy');
	const lazyImages = Array.from(imageCollection);

	// Function to fallback to normal image loading
	const fallbackToNormalLoading = () => {
		lazyImages.forEach(function(lazyImage) {
			const sourceElement = lazyImage.getElementsByTagName('source')[0];
			const imgElement = lazyImage.getElementsByTagName('img')[0];
			
			// Move data-src to src for normal loading
			if (sourceElement && sourceElement.dataset.src) {
				sourceElement.src = sourceElement.dataset.src;
				sourceElement.removeAttribute('data-src');
			}
			if (sourceElement && sourceElement.dataset.srcset) {
				sourceElement.srcset = sourceElement.dataset.srcset;
				sourceElement.removeAttribute('data-srcset');
			}
			if (imgElement && imgElement.dataset.src) {
				imgElement.src = imgElement.dataset.src;
				imgElement.removeAttribute('data-src');
			}
			if (imgElement && imgElement.dataset.srcset) {
				imgElement.srcset = imgElement.dataset.srcset;
				imgElement.removeAttribute('data-srcset');
			}
			
			// Remove lazy class to prevent any CSS hiding
			lazyImage.classList.remove('lazy');
		});
	};

	try {
		lazyImages.forEach(function(lazyImage) {
			const sourceElement = lazyImage.getElementsByTagName('source')[0];
			const imgElement = lazyImage.getElementsByTagName('img')[0];
			
			if (sourceElement) {
				sourceElement.classList.add('lazy');
			}
			if (imgElement) {
				imgElement.classList.add('lazy');
			}
		});

		const lazyLoadInstance = new LazyLoad({
			threshold: 0,
			callback_loaded: (e) => {
				// console.log('loaded finished\n', e)
			},
			callback_enter: (e) => {		
				// console.log('viewport enter \n', e)
			},
			callback_error: (e) => {
				console.warn('LazyLoad error for element:', e);
				// Fallback for individual failed elements
				const sourceElement = e.getElementsByTagName('source')[0];
				const imgElement = e.getElementsByTagName('img')[0];
				
				if (sourceElement && sourceElement.dataset.src) {
					sourceElement.src = sourceElement.dataset.src;
				}
				if (imgElement && imgElement.dataset.src) {
					imgElement.src = imgElement.dataset.src;
				}
			}
		});
	} catch (error) {
		console.warn('LazyLoad initialization failed, falling back to normal image loading:', error);
		fallbackToNormalLoading();
	}
		
};

if (
	document.readyState === "complete" ||
	(document.readyState !== "loading" && !document.documentElement.doScroll)
) {
	configureLazy();
} else {
	document.addEventListener("DOMContentLoaded", configureLazy);
}